/**
 * This component simply makes a decision based on a attribute in local storage
 * which customer search to show.  Customers = chicklets and 
 * CustomerSearchTable = table with pagination
 * 
 * Currently low customer count is 20 - see constant below.
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';


import Customers from './Customers';
import CustomerSearchTable from './CustomerSearchTable';


const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    flexGrow: 1
  },
  flex: {
    flex: 1,
  }
});

const lowCustCount = 0;

class CustomerSearch extends Component {
  
  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent } = this.props.auth;

    if (!isAuthenticated() || needAssent()) { 

      return ( <Redirect to='/home' /> );

    } else if (isAuthenticatedReseller()) {

      //see how many customers reseller has.
      let customerCount = 0;
      if (abEnvironment.getUserAttribute("cust_count")) {
        customerCount = parseInt(abEnvironment.getUserAttribute("cust_count"), 10)
      }
  
      if (customerCount <= lowCustCount) {
        return (
          <Customers auth={this.props.auth} {...this.props} />
        );
  
      } else {
        return (
          <CustomerSearchTable auth={this.props.auth} {...this.props} />
        )
      }
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

CustomerSearch.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(CustomerSearch);
